export const FS = {
  IDLE: 'IDLE',
  LOADING: 'LOADING',
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR',
} as const;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type FS = typeof FS;
export type FSKey = FS[keyof FS];
